import { QUERY_GC_TIME_MS, QUERY_STALE_TIME_MS } from "@/constants/config";
import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "./api-client";

export const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: QUERY_STALE_TIME_MS,
        gcTime: QUERY_GC_TIME_MS,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // Auth and validation problems never resolve by retrying.
          if (error instanceof ApiRequestError && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
